module.exports = new __parcel__URL__("qr.8585fc42.png").toString();